import { render, staticRenderFns } from "./Rank.vue?vue&type=template&id=140bfab7&scoped=true&"
import script from "./Rank.vue?vue&type=script&lang=ts&"
export * from "./Rank.vue?vue&type=script&lang=ts&"
import style0 from "./Rank.vue?vue&type=style&index=0&id=140bfab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140bfab7",
  null
  
)

export default component.exports